$('.answer').removeClass('show').queue(function(){
    $('.answer').addClass('hide');
    $(this).dequeue();
})

$('.question').on('click', function(){
    $(this).next().toggleClass('hide');
    $(this).next().toggleClass('show');
    $(this).toggleClass('rotate');
})